import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/BrandsOverview/BrandOverviewPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/BrandsOverview/redial';
import {SearchTypeTypes} from '@aboutyou/legacy-tracking-sdk';
import {useGetSearchRedirect} from '@aboutyou/logic-components';
import {useSearchEventsUtils} from '@aboutyou/tracking';
import {LegacyDesktopStyles} from '../styles/LegacyBaseStyles';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);
const PageWithProviders = withLegacyProviders(PageWithRedial);

export const BrandsOverview = () => {
  const getSearchRedirect = useGetSearchRedirect();
  const {updateSearchEventContextParams} = useSearchEventsUtils();

  const updateSearchContext = (term: string, searchType?: string) => {
    updateSearchEventContextParams({
      searchName: 'searchHotkey',
      searchTerm: term,
      searchType: (searchType || '') as SearchTypeTypes,
    });
  };

  return (
    <>
      <div className={LegacyDesktopStyles} />
      <PageWithProviders
        getSearchRedirect={getSearchRedirect}
        updateSearchContext={updateSearchContext}
      />
    </>
  );
};
